(function () {
  'use strict';

  function initCherianneSlider() {

    const slideshows = document.querySelectorAll('slideshow-component');

    if (!slideshows.length) return;

    slideshows.forEach(function (slideshow) {

      if (slideshow.dataset.cherianneInitialized === 'true') return;

      const slides = slideshow.querySelectorAll('.slideshow__slide');

      if (!slides.length) return;

      slideshow.dataset.cherianneInitialized = 'true';

      // =========================================================
      // SLIDE LINK SİSTEMİ
      // =========================================================

      slides.forEach(function (slide) {

        const slideLink = slide.dataset.slideLink;

        if (!slideLink) return;

        let pointerStartX = 0;
        let pointerStartY = 0;
        let pointerMoved = false;

        slide.addEventListener(
          'pointerdown',
          function (event) {

            // Slider kontrollerine dokunma
            if (
              event.target.closest(
                '.slider-button, .slider-counter__link, .cherianne-slider-pagination'
              )
            ) {
              return;
            }

            pointerStartX = event.clientX;
            pointerStartY = event.clientY;
            pointerMoved = false;

          },
          {
            passive: true
          }
        );

        slide.addEventListener(
          'pointermove',
          function (event) {

            if (
              Math.abs(event.clientX - pointerStartX) > 10 ||
              Math.abs(event.clientY - pointerStartY) > 10
            ) {
              pointerMoved = true;
            }

          },
          {
            passive: true
          }
        );

        slide.addEventListener(
          'click',
          function (event) {

            // Slider hareketi yapıldıysa link açma
            if (pointerMoved) {
              pointerMoved = false;
              return;
            }

            // Slider kontrollerine tıklanmışsa link açma
            if (
              event.target.closest(
                '.slider-button, .slider-counter__link, .cherianne-slider-pagination'
              )
            ) {
              return;
            }

            // Mevcut bir linke tıklanmışsa ikinci kez yönlendirme yapma
            if (event.target.closest('a')) {
              return;
            }

            window.location.href = slideLink;

          },
          false
        );

      });


      // =========================================================
      // SHOPIFY PAGINATION
      // =========================================================

      if (slides.length <= 1) return;

      const originalDots = slideshow.querySelectorAll(
        '.slider-counter__link--dots'
      );

      if (!originalDots.length) return;

      const controls = slideshow.querySelector(
        '.slideshow__controls'
      );

      if (controls) {
        controls.classList.add(
          'cherianne-original-controls'
        );
      }

      const pagination = document.createElement('div');

      pagination.className =
        'cherianne-slider-pagination';

      pagination.setAttribute(
        'aria-label',
        'Slider navigation'
      );

      pagination.setAttribute(
        'role',
        'tablist'
      );

      originalDots.forEach(function (originalDot, index) {

        const button = document.createElement('button');

        button.type = 'button';

        button.className =
          'cherianne-slider-dot';

        button.setAttribute(
          'aria-label',
          'Slide ' + (index + 1)
        );

        button.setAttribute(
          'aria-selected',
          originalDot.classList.contains(
            'slider-counter__link--active'
          )
            ? 'true'
            : 'false'
        );

        button.dataset.index = index;

        if (
          originalDot.classList.contains(
            'slider-counter__link--active'
          )
        ) {
          button.classList.add('is-active');
        }

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            event.stopPropagation();

            originalDot.click();

            updateActiveDot(index);

          }
        );

        pagination.appendChild(button);

      });

      slideshow.appendChild(pagination);


      // =========================================================
      // AKTİF DOT
      // =========================================================

      function updateActiveDot(activeIndex) {

        const newDots =
          pagination.querySelectorAll(
            '.cherianne-slider-dot'
          );

        newDots.forEach(function (dot, index) {

          const active =
            index === activeIndex;

          dot.classList.toggle(
            'is-active',
            active
          );

          dot.setAttribute(
            'aria-selected',
            active
              ? 'true'
              : 'false'
          );

        });

      }


      // =========================================================
      // SHOPIFY SLIDER DEĞİŞİKLİKLERİ
      // =========================================================

      const slider =
        slideshow.querySelector('.slideshow');

      if (slider) {

        const observer =
          new MutationObserver(
            function () {

              originalDots.forEach(
                function (dot, index) {

                  if (
                    dot.classList.contains(
                      'slider-counter__link--active'
                    )
                  ) {
                    updateActiveDot(index);
                  }

                }
              );

            }
          );

        observer.observe(
          slider,
          {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
          }
        );

      }


      // =========================================================
      // SHOPIFY SLIDE EVENT
      // =========================================================

      slideshow.addEventListener(
        'slideChanged',
        function (event) {

          if (
            event.detail &&
            typeof event.detail.currentPage !==
              'undefined'
          ) {

            const index =
              parseInt(
                event.detail.currentPage,
                10
              ) - 1;

            if (index >= 0) {
              updateActiveDot(index);
            }

          }

        }
      );

    });

  }


  // =========================================================
  // İLK ÇALIŞTIRMA
  // =========================================================

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initCherianneSlider
    );

  } else {

    initCherianneSlider();

  }


  // =========================================================
  // SHOPIFY THEME EDITOR
  // =========================================================

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        initCherianneSlider,
        100
      );

    }
  );

})();